module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="block table-hook">\n</div>\n\n<div class="actions">\n  <button type="button" class="button map '+
((__t=( disabled ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'>\n    Map Payment Items\n  </button>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./parentpay/templates/bankaccount/layout.html
// module id = 221
// module chunks = 0